import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { reactular } from '@vendhq/reactular'
import React, { FC } from 'react'
import { useT } from '@transifex/react'
import { useVdCurrencyFilter } from '../../../ng-compat/hooks'

export type PartialPaymentTypeName = 'Store Credit' | 'Loyalty'

interface Props {
  availableCredit: number
  paymentTypeName: PartialPaymentTypeName
  close: (applyPartialAuth: Promise<boolean>) => void
}

export const PartialPaymentModal: FC<Props> = ({
  availableCredit,
  paymentTypeName,
  close,
}) => {
  const t = useT()
  const vdCurrencyFilter = useVdCurrencyFilter()

  const cancelPartialPayment = () => {
    close(Promise.resolve(false))
  }

  const makePartialPayment = () => {
    close(Promise.resolve(true))
  }

  return (
    <Modal size="small" dismissable onClose={cancelPartialPayment}>
      <ModalHeader>
        {t('Pay {amount} with {paymentTypeName}', {
          amount: vdCurrencyFilter(availableCredit),
          paymentTypeName,
          _context: 'Payment modal header',
        })}
      </ModalHeader>
      <ModalContent>
        <p className="vd-p">
          {t(
            'You can only redeem up to the value of your current {paymentTypeName} balance. You may still continue with this as a partial payment, then choose another payment method for the remaining balance.',
            {
              paymentTypeName: paymentTypeName.toLowerCase(),
              _context: 'Partial payment modal content',
            }
          )}
        </p>
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button variant="supplementary" onClick={cancelPartialPayment}>
            {t('Choose a different payment type', {
              _context: 'Button label to choose a different payment type',
            })}
          </Button>
          <Button variant="go" onClick={makePartialPayment} autoFocus>
            {t('Make partial payment', {
              _context: 'Button label to make a partial payment',
            })}
          </Button>
        </div>
      </ModalActions>
    </Modal>
  )
}

export const PartialPaymentModalComponent = reactular(
  PartialPaymentModal,
  ['availableCredit', 'close', 'paymentTypeName'],
  'reactWrapper'
)
